import { ComercioApi as Api } from "./comercio.api";

export class ComercioFacade {
  static getMine() {
    return Api.getMine();
  }

  static getMinimumDiscountPercentage() {
    return Api.getMinimumDiscountPercentage();
  }

  static update(data) {
    return Api.update(data);
  }

  static uploadLogo(idComercio, logo) {
    return Api.uploadLogo(idComercio, logo);
  }
}
